<template>
  <main>
    <GridWrapper>
      <SectionSet isFirst>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <BreadCrumbs
            class="col-span-6 col-start-1 text-lg uppercase leading-[1.2] tracking-[0.08em] text-ng70 laptop:col-span-10 laptop:col-start-2 laptop:text-xl laptop:leading-[1.7]"
          />
          <h1
            class="col-span-6 col-start-1 text-lg leading-[1.4] laptop:col-span-7 laptop:col-start-2 laptop:text-[32px] laptop:leading-[1.7]"
          >
            {{ forBusinessFoodServicePageData?.forBusinessFoodServicePage?.data?.attributes?.hero_title }}
          </h1>
          <div
            class="col-span-6 mt-[9px] flex flex-col justify-end laptop:col-span-3 laptop:col-end-12 laptop:mt-12 desktop:mt-0"
          >
            <!--            <DownloadBtn class="laptop:self-end" :text="'olive packaging logistics'" />-->
            <!--            <DownloadBtn class="mt-[9px] laptop:mt-2 laptop:self-end" :text="'fruit packaging logistics'" />-->

            <DownloadBtn
              class="max-w-fit laptop:self-end"
              v-for="(file, index) in files"
              :key="index"
              :text="file.attributes?.packaging_brochure?.data?.attributes?.alternativeText"
              :href="file.attributes?.packaging_brochure?.data?.attributes?.url"
            />
          </div>
          <LargeImageContainer :image="'/images/three-barrels-bg.png'" :color="'bg-blue'" />
          <p class="col-span-6 col-start-1 mt-12 text-center laptop:col-span-8 laptop:col-start-3 laptop:mt-14">
            {{ forBusinessFoodServicePageData?.forBusinessFoodServicePage?.data?.attributes?.hero_paragraph }}
          </p>
        </div>
      </SectionSet>
      <SectionSet>
        <div class="grid-wrapper grid grid-cols-6 gap-x-6 laptop:grid-cols-12">
          <div
            class="col-span-6 col-start-1 flex flex-col space-y-6 laptop:col-span-10 laptop:col-start-2 laptop:flex-row laptop:space-y-0 laptop:space-x-6"
          >
            <LinkCard
              :bg="'bg-green'"
              :title="
                forBusinessFoodServicePageData?.forBusinessFoodServicePage?.data?.attributes?.tile_olive_packaging
                  ?.title
              "
              :subtitle="
                forBusinessFoodServicePageData?.forBusinessFoodServicePage?.data?.attributes?.tile_olive_packaging
                  ?.subtitle
              "
              :img="
                forBusinessFoodServicePageData?.forBusinessFoodServicePage?.data?.attributes?.tile_olive_packaging
                  ?.image?.data?.attributes?.url
              "
              :link="localePath({ name: 'products-packaging' })"
              :arrow="'#5B7E44'"
            />
            <LinkCard
              :bg="'bg-grey'"
              :title="
                forBusinessFoodServicePageData?.forBusinessFoodServicePage?.data?.attributes?.tile_fruit_packaging
                  ?.title
              "
              :subtitle="
                forBusinessFoodServicePageData?.forBusinessFoodServicePage?.data?.attributes?.tile_fruit_packaging
                  ?.subtitle
              "
              :img="
                forBusinessFoodServicePageData?.forBusinessFoodServicePage?.data?.attributes?.tile_fruit_packaging
                  ?.image?.data?.attributes?.url
              "
              :link="localePath({ name: 'products-packaging' })"
              :arrow="'#BB8822'"
            />
          </div>
        </div>
      </SectionSet>
    </GridWrapper>
    <SectionSet isLast>
      <div class="flex flex-col">
        <!--        <CustomizationSection class="w-full" />-->
        <NextBtn class="mx-auto mt-[91px] laptop:mt-[129px]" :text="$t('Contact us to discuss Food Service options')" />
      </div>
    </SectionSet>
  </main>
</template>
<script setup lang="ts">
const pageTitle = ref<string | null>(null);
const { locale, finalizePendingLocaleChange } = useI18n();

const localePath = useLocalePath();

await finalizePendingLocaleChange();

const { data: forBusinessFoodServicePageData } = await useAsyncGql({
  operation: "FoodServicePage",
  variables: { locale: locale.value },
  options: {
    lazy: false,
  },
});

const files = computed(() => {
  return (
    forBusinessFoodServicePageData.value?.productTypes?.data.filter((p) => {
      return !!p.attributes?.packaging_brochure?.data;
    }) || []
  ); //.filter((p) => p.attributes.slug === "packaging")[0]?.attributes?.files?.data;
});

watch(
  forBusinessFoodServicePageData,
  (newVal) => {
    if (newVal) {
      if (newVal.forBusinessFoodServicePage?.data?.attributes?.seo?.metaTitle) {
        pageTitle.value = newVal.forBusinessFoodServicePage?.data?.attributes?.seo?.metaTitle;
      }
      useHead({
        title: () => pageTitle.value,
      });
      useServerSeoMeta({
        title: () => `${newVal.forBusinessFoodServicePage?.data?.attributes?.seo?.metaTitle}`,
        ogTitle: () => `${newVal.forBusinessFoodServicePage?.data?.attributes?.seo?.metaTitle}`,
        description: () => `${newVal.forBusinessFoodServicePage?.data?.attributes?.seo?.metaDescription}`,
        ogDescription: () => `${newVal.forBusinessFoodServicePage?.data?.attributes?.seo?.metaDescription}`,
        ogImage: () => `${newVal.forBusinessFoodServicePage?.data?.attributes?.seo?.metaImage?.data?.attributes?.url}`,
      });
    }
  },
  { immediate: true },
);
</script>
<style lang="scss" scoped></style>
